export const purpurTypographyFamilyDefault =
  "TeliaSans, Helvetica, Arial, 'Lucida Grande', sans-serif";
export const purpurTypographyFamilyDisplay =
  "TeliaSansHeading, Helvetica, Arial, 'Lucida Grande', sans-serif";
export const purpurTypographyWeightNormal = "400";
export const purpurTypographyWeightMedium = "500";
export const purpurTypographyWeightBold = "700";
export const purpurTypographyLineHeightTight = "100%";
export const purpurTypographyLineHeightSnug = "110%";
export const purpurTypographyLineHeightDefault = "125%";
export const purpurTypographyLineHeightLoose = "150%";
export const purpurTypographyLineHeightLooser = "175%";
export const purpurTypographyScale50 = "0.75rem";
export const purpurTypographyScale75 = "0.875rem";
export const purpurTypographyScale100 = "1rem";
export const purpurTypographyScale150 = "1.125rem";
export const purpurTypographyScale200 = "1.25rem";
export const purpurTypographyScale300 = "1.375rem";
export const purpurTypographyScale400 = "1.5rem";
export const purpurTypographyScale500 = "1.75rem";
export const purpurTypographyScale600 = "2rem";
export const purpurTypographyScale650 = "2.25rem";
export const purpurTypographyScale700 = "2.5rem";
export const purpurTypographyScale800 = "3rem";
export const purpurTypographyScale850 = "3.5rem";
export const purpurTypographyScale900 = "4rem";
export const purpurTypographyScale1000 = "5rem";
export const purpurTypographyScale1100 = "6rem";
